import React from 'react';
import { FONT_WEIGHT, RADIUS, SPACING } from '../../constants/constants';
import { useThemeTokens } from '../../hooks/UseThemeTokens';

/**
 * 네이버 재고 수량 표시(감사 card-controltower#447 — 매장 가격 요청 재고 칸 #348 과 같은 모양). 없으면 '-', 0 은 품절이라 빨간
 * 배경으로 눈에 띄게. props 만으로 그리는 공용 컴포넌트.
 */
export const AppStockCount: React.FC<{ stock: number | null | undefined; testId?: string }> = ({ stock, testId }) => {
  const t = useThemeTokens();
  if (stock == null) {
    // '재고 모름' 도 읽어야 하는 정보라 빈 칸 색(textEmpty 3.39:1)이 아니라 흐린 글자(textMuted 4.5:1+)로(코덱 화면 점검 2026-10-30, 감사 #518).
    return <span data-testid={testId} title="CT 카드 목록에 재고가 없습니다" aria-label="재고 정보 없음" style={{ color: t.textMuted }}>-</span>;
  }
  if (stock <= 0) {
    return (
      <span
        data-testid={testId}
        data-zero="true"
        title="재고 0 — 품절"
        style={{
          color: t.danger, background: t.tintDanger, fontWeight: FONT_WEIGHT.bold,
          padding: `0 ${SPACING.xxs}px`, borderRadius: RADIUS.sm, whiteSpace: 'nowrap',
        }}
      >
        0
      </span>
    );
  }
  return (
    <span data-testid={testId} style={{ color: t.textSecondary, fontVariantNumeric: 'tabular-nums' }}>
      {stock.toLocaleString('ko-KR')}
    </span>
  );
};
